import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent, ModalComponent } from '@webapp/ui';
import { ApiKeyRow } from '../../../interfaces/api-keys.interface';

/** Presentational confirm dialog. The parent renders it only while a delete is pending. */
@Component({
	selector: 'app-api-key-delete-modal',
	standalone: true,
	imports: [ButtonComponent, ModalComponent],
	templateUrl: './api-key-delete-modal.component.html',
	styleUrl: './api-key-delete-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiKeyDeleteModalComponent {
	apiKey = input.required<ApiKeyRow>();
	deleting = input<boolean>(false);

	confirm = output<void>();
	dismissed = output<void>();
}
